<div class="main-wrapper">
    <div class="act-search-bar">
        <div class="search-with-dropdown">
            <mat-form-field appearance="fill" class="dropdown-field-mat">
                <mat-select
                        aria-label="Vehicle data field"
                        panelClass="faulty-vehicle-select-panel"
                        [value]="faultyVehicleDataService.selectedField()"
                        (selectionChange)="onFieldChange($event)">
                    <mat-option *ngFor="let field of vehicleDataFields" [value]="field">
                        {{ getFieldLabel(field) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="search-field">
                <input #queryInput type="search" [value]="searchInput()"
                       [placeholder]="'Search for ' + searchPlaceholder()"
                       [attr.aria-label]="'Search for ' + searchPlaceholder()"
                       (input)="onSearchInput(queryInput.value)">
                <i class="bi bi-search" aria-hidden="true"></i>
            </div>
        </div>
    </div>

    <div class="main" [class.has-selection]="selectedFaultyValue() !== null">
        <div class="faulty-table-wrapper">
            <app-faulty-vehicle-data-table
                    [faultyDataList]="faultyVehicleDataService.faultyDataList()"
                    [selectedValue]="selectedFaultyValue()"
                    (faultyValueSelected)="getFaultyValue($event)">
            </app-faulty-vehicle-data-table>
        </div>

        <div class="pure-original-table">
            @if (selectedFaultyValue() !== null) {
                <app-pure-original-faulty-vehicle-data-table class="selected-records"
                                                              [faultyValue]="selectedFaultyValue()"/>
            } @else {
                <div class="selection-placeholder">
                    <i class="bi bi-list-check" aria-hidden="true"></i>
                    <h2>{{ selectionTitle() }}</h2>
                    <p>Choose a name from the list to review its Pure Originals.</p>
                </div>
            }
        </div>
    </div>
</div>
